import accounting from 'accounting';
import { Table } from 'antd';

import styles from './index.module.less';
import { getAddressString } from '../../../lib/modelHelpers/object';
import { formatTextToReact } from '../../../lib/utils/textFormatting';

export type EstimateItemData = {
  readonly id: string;
  readonly title: string;
  readonly description: string | null | undefined;
  readonly quantity: number;
  readonly unit: string | null | undefined;
  readonly unitPrice: number;
  readonly taxRate: number;
  readonly object:
    | {
        readonly name: string | null | undefined;
        readonly streetAddress: string | null | undefined;
        readonly zip: string | null | undefined;
        readonly city: string | null | undefined;
      }
    | null
    | undefined;
};

export type EstimateItemsTableProps = {
  items?: readonly EstimateItemData[] | null;
};

function EstimateItemsTable(props: EstimateItemsTableProps) {
  return (
    <>
      <Table
        className={styles.fullSizeTable}
        dataSource={props.items ?? []}
        columns={[
          {
            title: 'Titel',
            dataIndex: 'title',
            render: (text, item: EstimateItemData) => (
              <>
                <strong>{item.title}</strong>
                <br />
                {item.description != null && (
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    {formatTextToReact(item.description)}
                  </div>
                )}
                {item.object && (
                  <div>
                    Objekt:{' '}
                    {item.object.name &&
                      item.object.name + (getAddressString(item.object) !== '' ? ', ' : '')}
                    {getAddressString(item.object)}
                  </div>
                )}
              </>
            ),
          },
          {
            title: 'Menge',
            dataIndex: 'quantity',
            render: (text, item: EstimateItemData) => (
              <div style={{ whiteSpace: 'nowrap' }}>
                {accounting.formatMoney(item.quantity, '', 2, '.', ',') +
                  (item.unit ? ' ' + item.unit : '')}
              </div>
            ),
          },
          {
            title: 'Einheit',
            dataIndex: 'unitPrice',
            render: (text, item: EstimateItemData) => (
              <div style={{ whiteSpace: 'nowrap' }}>
                {accounting.formatMoney(item.unitPrice / 100, '', 2, '.', ',') + ' €'}
              </div>
            ),
          },
          {
            title: 'Steuersatz',
            dataIndex: 'taxRate',
            render: (text, item: EstimateItemData) => (
              <div style={{ whiteSpace: 'nowrap' }}>{item.taxRate + ' %'}</div>
            ),
          },
          {
            title: 'Betrag',
            dataIndex: 'amount',
            render: (text, item: EstimateItemData) => (
              <div style={{ whiteSpace: 'nowrap' }}>
                {accounting.formatMoney(
                  accounting.toFixed(item.unitPrice * item.quantity, 0) / 100,
                  '',
                  2,
                  '.',
                  ','
                ) + ' €'}
              </div>
            ),
          },
        ]}
        pagination={false}
      />
      <Table
        className={styles.mobileTable}
        dataSource={props.items ?? []}
        columns={[
          {
            title: 'Titel',
            dataIndex: 'title',
            render: (text, item: EstimateItemData) => (
              <>
                <strong>
                  {accounting.formatMoney(item.quantity, '', 2, '.', ',') +
                    (item.unit ? ' ' + item.unit : ' x')}{' '}
                  {item.title}
                </strong>
                <br />
                {item.description != null && (
                  <div style={{ whiteSpace: 'pre-wrap' }}>
                    {formatTextToReact(item.description)}
                  </div>
                )}
                {item.object && (
                  <div>
                    Objekt:{' '}
                    {item.object.name &&
                      item.object.name + (getAddressString(item.object) !== '' ? ', ' : '')}
                    {getAddressString(item.object)}
                  </div>
                )}
              </>
            ),
          },
          {
            title: 'Betrag',
            dataIndex: 'amount',
            render: (text, item: EstimateItemData) => (
              <div style={{ whiteSpace: 'nowrap' }}>
                <strong>
                  {accounting.formatMoney(
                    accounting.toFixed(item.unitPrice * item.quantity, 0) / 100,
                    '',
                    2,
                    '.',
                    ','
                  ) + ' €'}
                </strong>
                <br />
                USt.: {item.taxRate + ' %'}
              </div>
            ),
          },
        ]}
        pagination={false}
      />
    </>
  );
}

export default EstimateItemsTable;
